export default __webpack_public_path__ + "static/3-2d92df8eedf2fd51c944052caaf06c57.svg";